import React, { useCallback } from 'react';
import { Handle } from 'react-flow-renderer';
import { useDisclosure } from '@chakra-ui/react';
import NodePreviewModal from './NodePreviewModal';

const customNodeStyles = {
	background: '#fff',
	color: '#474747',
	padding: '10px 30px',

	fontSize: '19px',
	fontFamily: 'lato',
	fontWeight: 500,
	letterSpacing: 0.5,

	borderRadius: 30,
	borderWidth: 2,
	borderStyle: 'solid',

	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

const CustomSwitchNode = ({ data }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const getOuputHandles = useCallback(() => {
		const numOfOutputs = data.numOfOutputs || 1;
		return [...Array(numOfOutputs)].map((e, i) => (
			<Handle
				key={i + 1}
				id={`${i + 1}`}
				type="source"
				position={'right'}
				style={{
					width: 17,
					height: 17,
					borderRadius: '50%',
					borderWidth: 0,
					top: `${(i + 1) * (100 / (numOfOutputs + 1))}%`,
					right: '-7px',
					background: data.color || '#a1a1a1',
					zIndex: 1,
				}}
			/>
		));
	}, [data.color, data.numOfOutputs]);

	return (
		<div
			style={{
				...customNodeStyles,
				borderColor: data.color || '#a1a1a1',
				height: data.numOfOutputs ? 18 + 11 * data.numOfOutputs : undefined,
			}}
			onDoubleClick={onOpen}
		>
			<Handle
				type="target"
				position={'left'}
				style={{
					width: 17,
					height: 17,
					borderRadius: '50%',
					borderWidth: 0,
					left: '-7px',
					background: data.color || '#a1a1a1',
					zIndex: -1,
				}}
			/>
			<div>{data.label}</div>
			<NodePreviewModal
				isOpen={isOpen}
				onOpen={onOpen}
				onClose={onClose}
				metadata={data.orgMetaData}
				label={data.label}
			/>
			{getOuputHandles()}
		</div>
	);
};

export default CustomSwitchNode;
